<template>
  <div class="flex items-center gap-1 text-label">
    <email-status v-if="item" :email="item" class="shrink-0" />
    <provider-image :provider="iconInfo.provider" alt="Email Provider Icon" />
    <div
      v-if="item.is_outgoing"
      class="flex min-w-0 flex-1 items-center space-x-0-5"
    >
      <span v-if="item.sender?.name" v-tooltipable class="min-w-0 truncate">
        {{ item.sender.name }}
      </span>
      <span v-if="item.receiver?.name" class="shrink-0 truncate">
        {{ $t("COMMON.TO") }}:
      </span>
      <span v-if="item.receiver?.name" v-tooltipable class="min-w-0 truncate">
        {{ item.receiver.name }}
      </span>
    </div>
    <div v-else class="flex min-w-0 flex-1">
      <div v-if="item.sender?.name" class="flex items-center space-x-0-5">
        <span class="shrink-0 whitespace-nowrap">{{ $t("COMMON.FROM") }}:</span>
        <span v-tooltipable class="max-w-30 shrink-0 truncate">
          {{ item.sender.name }}
        </span>
      </div>
    </div>
    <date-time :date="item.created_at" class="shrink-0 whitespace-nowrap" />
  </div>
</template>
<script setup lang="ts">
import { useEmailLogInfo } from "@/hooks/communicationLogs";

import ProviderImage from "@/components/communicationLogs/communication/ProviderImage.vue";
import EmailStatus from "@/components/communicationLogs/communication/emailThread/EmailStatus.vue";
import DateTime from "@/components/ui/ConvertibleDateTime.vue";

import type { EmailLogData } from "@/models/communicationLogs";

const { item } = defineProps<{
  item: EmailLogData;
}>();

const { iconInfo } = useEmailLogInfo(item);
</script>
